<template>
  <div class="all-c contact-section index" id="contact">
    <div>
<!--      <div class="en" v-show="isEnglish">-->
        <div class="contact-info">
          <h2 class="contact-title">{{ $t('contactUsTitle') }}</h2>
          <p class="contact-description">{{ $t('contactUsDescription') }}</p>
        </div>
        <div class="contact-content">
          <div class="title-box">
            <div class="mobile-barcode">
              <img src="../../public/barcode.png" />
            </div>
            <div>
              <h3 class="reachout-title">{{ $t('reachOutTitle') }}</h3>
              <div class="contact-details">
                <p>
                  <img src="../../public/weixin.png" />
                  <span>WeChat: Charlotte-and-you</span>
                </p>
                <p>
                  <img src="../../public/icon-email2.png" />
                  <span> E-mail: Service@charlotteandyou.cn</span>
                </p>
              </div>
            </div>

          </div>
          <div class="barcode">
            <img src="../../public/barcode.png" style="width: 7vw;" />
          </div>
          <div class="content-box">
            <div class="contact-form">
              <div class="contact-user">
                <p>
                  <img src="../../public/icon-name.png" style="display: inline-block;" />
                  {{ $t('nameLabel') }}
                </p>
                <p><input type="text" id="name" v-model="form.name">
                <span v-if="formErrors.name" style="color: red;">{{ formErrors.name }}</span></p>

              </div>
              <div class="contact-email">
                <p>
                  <img src="../../public/icon-email.png" style="display: inline-block;" />
                  {{ $t('emailLabel') }}
                </p>
                <p><input type="text"  id="email" v-model="form.email">
                <span v-if="formErrors.email" style="color: red;">{{ formErrors.email }}</span></p>

              </div>
              <div class="contact-email">
                <p>
                  <img src="../../public/icon-concern.png" style="display: inline-block;" />
                  {{ $t('concernLabel') }}
                </p>
                <p><textarea name="" id="desc" cols="30" rows="3" v-model="form.concern"></textarea>
                <span v-if="formErrors.concern" style="color: red;">{{ formErrors.concern }}</span></p>

              </div>
              
              <div class="contact-verify">
                <span>
                  {{ $t('CAPTCHA') }}
                </span>
              </div>
              <p class="contact-submit">
                <a  id="button" @click="handleSubmit">{{ $t('submitButton') }}</a>
              </p>
            </div>
          </div>
          <div class="contact-bg">
            <img class="bg-img" src="../../public/9.png" alt="">
          </div>
        </div>
<!--      </div>-->
      <mpanel v-if="mpanelShow"
              @close="mpanelShow = false"
              @success="onMpanelSuccess"></mpanel>
<!--      <div class="cn" v-show="!isEnglish">
        <div class="contact-info">
          <h2 class="contact-title">{{ $t('contactUsTitle') }}</h2>
          <p class="contact-description">{{ $t('contactUsDescription') }}</p>
        </div>
        <div class="contact-content">
          <div class="title-box">
            <div class="mobile-barcode">
              <img src="../../public/barcode.png" />
            </div>
            <div>
              <h3 class="reachout-title">{{ $t('reachOutTitle') }}</h3>
              <div class="contact-details">
                <p>
                  <img src="../../public/weixin.png" />
                  <span>微信: Charlotte-and-you</span>
                </p>
                <p>
                  <img src="../../public/icon-email2.png" />
                  <span> 邮箱: Service@charlotteandyou.cn</span>
                </p>
              </div>
            </div>

          </div>
          <div class="barcode">
            <img src="../../public/barcode.png" style="width: 7vw;" />
          </div>
          <div class="content-box">
            <div class="contact-form">
              <div class="contact-user">
                <p>
                  <img src="../../public/icon-name.png" style="display: inline-block;" />
                  {{ $t('nameLabel') }}
                </p>
                <input type="text" id="name" v-model="form.name">
                <span v-if="formErrors.name" style="color: red;">{{ formErrors.name }}</span>

              </div>
              <div class="contact-email">
                <p>
                  <img src="../../public/icon-email.png" style="display: inline-block;" />
                  {{ $t('emailLabel') }}
                </p>
                <input type="text"  id="email" v-model="form.email">
                <span v-if="formErrors.email" style="color: red;">{{ formErrors.email }}</span>

              </div>
              <div class="contact-email">
                <p>
                  <img src="../../public/icon-concern.png" style="display: inline-block;" />
                  {{ $t('concernLabel') }}
                </p>
                <textarea name="" id="desc" cols="30" rows="3" v-model="form.concern"></textarea>
                <span v-if="formErrors.concern" style="color: red;">{{ formErrors.concern }}</span>

              </div>

              <div class="contact-verify">
                <span>
                  {{ $t('CAPTCHA') }}
                </span>
              </div>
              <p class="contact-submit">
                <a  id="button" @click="handleSubmit">{{ $t('submitButton') }}</a>
              </p>
            </div>
          </div>
          <div class="contact-bg">
            <img class="bg-img" src="../../public/9.png" alt="">
          </div>
        </div>
      </div>-->
    </div>
  </div>
</template>

<script>
// import {  Button } from 'ant-design-vue';
import { reactive  } from 'vue';
import Mpanel from '@/components/Mpanel.vue'   //验证码
import axios from 'axios';
import {SENG_EMAIL} from "@/config";

export default {
  components: {
    // 'a-form': Form,
    // 'a-form-item': Form.Item,
    // 'a-input': Input,
    // 'a-button': Button,
    Mpanel
  },
  data() {
    return {
      isEnglish: true,
      isFormVisible: false,
      isVerified: false,
      mpanelShow: false, //验证码是否显示
      captcha: null,
      form: reactive({
        name: '',
        email: '',
        concern: ''
      }),
      formErrors: {
        name: '',
        email: '',
        concern: ''
      }
    };
  },
  computed: {
    currentLang() {
      return this.$i18n.locale;
    }
  },
  watch: {
    currentLang(newLang) {
      this.isEnglish = newLang === 'en';
    },
    'form.name'() {
      this.validateField('name');
    },
    'form.email'() {
      this.validateField('email');
    },
    'form.concern'() {
      this.validateField('concern');
    }
  },
  methods: {
    toggleForm() {
      this.isFormVisible =!this.isFormVisible;
    },
    // 是否要验证
    openVerify() {
      this.mpanelShow = true;
    },
    // 验证通过
    onMpanelSuccess() {
      this.mpanelShow = false;
      this.isVerified = true;
      //执行代码
      this.sendEmail();

      this.isVerified = false;
    },
    validateField(field) {
      if (!this.form[field]) {
        this.formErrors[field] = '该字段为必填项';
      } else {
        this.formErrors[field] = '';
      }
      if(field === 'email') {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(this.form[field])) {
          this.formErrors[field] = '请输入正确的邮箱格式';
        } else {
          this.formErrors[field] = '';
        }
      }
    },
    handleSubmit() {
      // 手动验证所有字段
      this.validateField('name');
      this.validateField('email');
      this.validateField('concern');
      const hasErrors = Object.values(this.formErrors).some(error => error);
      if(!hasErrors){
        this.mpanelShow = true;
      }
    },
    sendEmail() {
      const apiUrl = SENG_EMAIL; // 替换为你的后端 API 地址
      const formData = {
        name: this.form.name,
        email: this.form.email,
        concern: this.form.concern
      };

      axios.post(apiUrl, formData)
          .then(response => {
            console.log('邮件发送成功', response.data);
            // 可以在这里添加提示用户邮件发送成功的逻辑
            this.form = {
              name: '',
              email: '',
              concern: ''
            }
            this.formErrors = {
                name: '',
                email: '',
                concern: ''
            }
          })
          .catch(error => {
            console.error('邮件发送失败', error);
            // 可以在这里添加提示用户邮件发送失败的逻辑
          });
    }
  }
};
</script>

<style scoped lang="less">
@mainBg: #f8f5f0;
@mainBg2: #f8f5f1;
@mainColor1: #de94a4;
@mainColor2: #eebac0;
@mainColor3: #A98578;
@mainFont: "MontserratMedium", sans-serif;
@mainFontSub: "MontserratLight", sans-serif;
@mainFontCn: 'Huangchan', sans-serif;
.contact-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 1vw;
  > div {
    width: 75%;
    padding: 2vw 0;
  }
  div[class*="mobile-"] {
    display: none;
  }
  .contact-info {
    width: 62%;
    align-self: flex-start;
    font-weight: 600;
    .contact-title {
      display: none;
      font-size: 2em;
      font-weight: 600;
      color: @mainColor3;
      margin: 0;
    }

    .contact-description,
    .contact-details {
      font-size: 1.5em;
    
      margin: 0;
    }
  }
  .contact-content {
    position: relative;
    font-size: 1vw;
    font-weight: 600;
    .title-box {
      position: absolute;
      top: 0;
      left: 0;
      .reachout-title {
        font-weight: 600;
        font-size: 2em;
        color: @mainColor3;
        margin: 0;
      }
    }
    .contact-details {
      font-size: 1.5em;
      > p {
        display: flex;
        align-items: center;
        gap: 1vw;
        margin: 0;
        > img {
          width: 1.5vw;
        }
        > span {
          flex: 1;
        }
      }
    }
  }
  .barcode {
    position: absolute;
    top: 60%;
    left:55%;
    transform: translate(-50%, -50%);
  }
  .content-box {
    position: absolute;
    bottom: 0;
    right: 0;
    width:38%;
    height: 78%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1vw;
    .contact-form {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      padding: 2em;
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 0.35em;
      > div {
        display: flex;
        align-items: center;
        gap: 1%;

        >p:first-child {
          width: 33%;
          display: flex;
          align-items: center;
          gap: 0.5em;
          margin: 0;
          color: #fff;
          > img {
            width: 24%;
          }
        }

        >p:last-child {
          flex: 1;
          margin: 0;

          >input,
          textarea {
            width: 100%;
            box-sizing: border-box;

            padding: 1em;
            margin-bottom: 0.5em;
            border-radius: 0.5em;
            border: none;
            background: #fff;

            &:focus {
              outline: none;
            }
          }
        }
      }
      .contact-verify {
        align-self: flex-end;
        background: #d4d4d4;
        width: 84%;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 1em;
        > span {
          display: inline-block;
          text-align: center;
          color: #0091c7;
          font-size: 2em;
          font-weight: 300;
          padding: 0.2em;
          box-sizing: border-box;

        } 
      }
      .contact-submit {
        text-align: right;
        padding-left: 40%;
        a {
          text-align: center;
          display: block;
          background-color: @mainColor3;
          color: white;
          padding: 1vw 2vw;
          border-radius: 1vw;
          cursor: pointer;
          &:hover {
            background-color: @mainColor1;
          }
        }
      }
    }
  }
  
}
@media screen and (max-width: 768px) {
  .all-c {
    &.contact-section {
      height: auto;
      padding: 3vw 0;
      > div {
        width: 85%;
        .barcode {
          display: none;
        }
        .contact-info {
          width: 100%;
          .contact-title {
            display: block;
            text-align: center;
            font-size: 4em;
            font-weight: 600;
            color: @mainColor3;
            margin: 0;
            text-align: center;
          }
          .contact-description {
            font-size: 3vw;
          }
        }
        .contact-content {
          .title-box {
            position: static;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 2vw;
            font-size: 2em;
            .contact-details {
              > p {
                > img {
                  width: 4vw;
                }
              }
            }
            .reachout-title {
              display: none;
            }
          }
          .title-box {
            .mobile-barcode {
              width: 31vw;
              padding: 1.5vw;
              background: #d2a48a;
              margin: 2vw;
            }
          }
        }
        .content-box {
          width: 90%;
          margin: 0 auto;
          position:static!important;
          background: #eebac0;
          margin-top: 5vw;
          border-radius: 2vw;
          .contact-form {
            gap: 2em;
            margin-top: 2vw;
            padding: 5vw;
            > div {
              flex-direction: column;
              align-items: flex-start;
              gap: 2vw;

              >p {
                font-size: 2.7vw;
                width: 100% !important;

                >img {
                  width: 4vw;
                }

                &:last-child {

                  input,
                  textarea {
                    width: 100%;
                    font-size: 2.7vw;
                  }
                }
              }
              &.contact-verify {
                width: 100%!important;
                span {
                  padding: 1em!important;
                  font-size: 2.486vw;
                }
              }
            }
            .contact-submit {
              padding: 0;
              a {
                padding: 0.5em!important;
                font-size: 3vw;
              }
            }
          }
        }
        .contact-bg {
          display: none;
        }
      }
    }
  }
  div[class*="mobile-"] {
    display: block!important;
  }
}
</style>